import React from "react";

import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { TextField, FormControlLabel, RadioGroup, Radio, IconButton, Typography, Dialog, Grid, Paper } from "@material-ui/core";
import { RadioButtonUnchecked, RadioButtonChecked, Close } from "@material-ui/icons";

import PrintIcon from '@material-ui/icons/Print';
import moment from "moment";

import { OfflineRfsOrder } from '../../../models/OfflineRfs';
//Table imports
import MaterialTable from "material-table";
import tableIcons from "../../../utils/editTableIcons";
import RfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';
import logo from '../../../assets/polar.png';

const Awb = {
  code: "string",
  delivered: "boolean",
  destination: "string",
  number: "string",
  origin: "string",
  weight: "string",
  org: "string",
  dst: "string",
  returned: "boolean",
  pieces: "string",
  specials: "string",
  remarks_text: "string",
};

const styles = (theme: Theme) =>
  createStyles({
    tablewrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    tableWrapperPadding:{
      padding: '20px'
    },
    wrapper3: {
      borderBottom: "1px solid gray",
      textAlign: "center",
      padding: '10px'
    },
    hr: {
      display: "block",
      height: "1px",
      border: "0",
      borderTop: "1px solid #ccc",
      margin: "1em 0",
      padding: "0",
      marginBottom: "30px",
    },
    flexAndRow: {
      display: "flex",
      flexDirection: "row",
    },
    titleWrapper: {
      width: "42%",
    },
    header: {
      marginTop: "-12px",
      marginLeft: "5px",
      width: "112px",
      backgroundColor: "white",
      padding: "0 4px 4px 4px",
      color: "rgb(0, 50, 97)",
    },
    button: {
      width: "100%",
      height: "34px",
      textTransform: "none",
    },
    finalise: {
      marginTop: '10px'
    },
    fileUpload: {
      display: "none",
    },
    btnWrapper: {
      paddingTop: "16px",
    },
    red: {
      color: "#d9001b",
    },
    truckTypeRadio: {
      "& > span": {
        paddingRight: 0,
        paddingTop: '20px',
        paddingBottom: 0,
      },
      "& p": {
        fontSize: "13px",
        color: "var(--primaryblue)",
        paddingLeft: "2px",
      },
    },
    select: {
      width: "90px",
    },
    filter: {
      marginLeft: "0px !important",
    },
    deleteDisable: {
      color: "rgb(204, 204, 204)",
    },
    manifestfielddata: {
      margin: "auto",
      "& input,  textarea": {
        color: "var(--primaryblue)",
        backgroundColor: "transparent !important",
        fontSize: "12px !important",
        textAlign: "center",
        overflow: "hidden",
      },
      "& fieldset": {
        color: "#013261 !important",
      },
      "& .MuiOutlinedInput-multiline-91": {
        padding: 0,
      },
      width: "100%",
    },
    manifestfielddataLeft: {
      margin: "auto",
      "& input,  textarea": {
        padding: "6px 8px !important",
        color: "var(--primaryblue)",
        backgroundColor: "transparent !important",
        fontSize: "12px !important",
        textAlign: "left",
        overflow: "hidden",
      },
      "& fieldset  ": {
        color: "#013261 !important",
      },
      "& .MuiOutlinedInput-multiline-91  ": {
        padding: 0,
      },
      width: "100%",
    },
    dateicon: {
      marginRight: "15px",
      width: "18px",
      height: "18px",
      marginBottom: "5px",
    },
    manifestTable: {
      width: "850px",
      marginLeft: "auto",
      marginRight: "auto",
      "& th":{
        textAlign: "center",
        padding: "4px 10px 4px 8px",
        width: "20%"
      },
      "& td": {
        textAlign: "center",
        padding: "4px 10px 4px 8px",
        width: "20%"
      }
    },
  });

interface ManifestInfoProps {
  classes: any;
  savedSignatureUrl: string;
  closeDialog: (boxType: string) => void;
  onClick: (event: any) => void;
  doo: OfflineRfsOrder;
  view: string;
  printContent: (id?: number) => void;
}

const manifestInfo = (props: ManifestInfoProps) => {
  const { classes } = props;

  return (
      <div className={ RfsStyles.manifestModal } >
        <div className={ RfsStyles.manifestWrapper } >
          { props.view === 'render' ? <div className={ RfsStyles.manifestHeader }>
            <div className={ RfsStyles.manifestsHeaderText }>RFS Manifest Details - { props.doo.flight + props.doo.rfs_number} </div>
            <div className={ RfsStyles.manifestHeaderButtons }>
              <div className={ RfsStyles.manifestModalButton1 } 
                onClick={ ()=> props.printContent(props.doo.id) } 
              >
                <IconButton aria-label="Close">
                  <PrintIcon color="primary" />
                </IconButton> 
              </div>
              <div className={ RfsStyles.manifestModalButton2 } onClick={(events) => props.closeDialog("ManifestDetails")} >
                <IconButton aria-label="Close">
                  <Close color="primary"/>
                </IconButton> 
              </div>
            </div>
          </div> : <div></div> }
          <div id="printArea" className={ RfsStyles.printarea }>
            <div className={ [classes.wrapper3].join(' ') }>
              <div>AIR CARGO TRANSFER MANIFEST</div>
            </div>
            <div className={ RfsStyles.mainfestForm }>
              <div className={ RfsStyles.mainfestRow }>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                    <h3 className= { [commonStyles.inputLabel, commonStyles.my0].join(' ') } >ORG-DES</h3>
                    <TextField
                      id="outlined-helperText"
                      disabled={true}
                      className={ classes.manifestfielddata}
                      value= {""+props.doo.org.toUpperCase()+"-"+props.doo.dst.toUpperCase()}
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') } > 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Dept</h3>

                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value={ moment(props.doo.schedule_date,"YYYYMMDD").format("DDMMMYY")+" "+props.doo.schedule_time } 
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') } > 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Scheduled Arrival</h3>
                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata } 
                      value={ moment(props.doo.schedule_arr_date,"YYYYMMDD").format("DDMMMYY")+ " " + props.doo.schedule_arr_time }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Actual Arrival Date</h3>
                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value={ props.doo.arrival_date? moment(props.doo.arrival_date,"YYYYMMDD").format("DDMMMYY"): "" }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Actual Arrival Time</h3>
                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value={ props.doo.arrival_time? props.doo.arrival_time : "" }
                      variant="outlined"
                    />
                  </div>
                </div>
              </div>
              <div className={ RfsStyles.mainfestRow }>
                <Grid container className={ RfsStyles.maniPrintGridItemContainer }>
                  <Grid item sm={5} xs={12} className={ [classes.mainfestfieldborder, RfsStyles.maniPrintGridItem].join(' ') }>
                    <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                      <label className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Pick Up From</label>

                      <TextField
                        id="outlined-helperText"
                        disabled={ true }
                        className={ classes.manifestfielddata }
                        multiline
                        rows="3"
                        rowsMax="3"
                        InputProps={{ classes: { root: classes.textFieldip } }}
                        value= { props.doo.pickpointname + '\r\n'+ (props.doo.pickinfo? props.doo.pickinfo.addr1 +'\n'+ (props.doo.pickinfo.addr2? props.doo.pickinfo.addr2+'\n' : '') + props.doo.pickinfo.city+','+props.doo.pickinfo.state +' '+props.doo.pickinfo.zip : '') }
                        variant="outlined"
                      />
                    </div>
                  </Grid>
                  <Grid item sm={2} xs={12} className={ [RfsStyles.manifestStateWrapper, RfsStyles.maniPrintGridItem].join(' ') }>
                    <div className={ RfsStyles.manifestState  }>
                      { props.doo.org.toUpperCase()+"-"+props.doo.dst.toUpperCase() }
                    </div>                  
                  </Grid>
                  <Grid item sm={5} xs={12} className={ [classes.mainfestfieldborder,RfsStyles.maniPrintGridItem].join(' ') }>
                    <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                      <label className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Drop To</label>

                      <TextField
                        id="outlined-helperText"
                        disabled={ true }
                        className={ classes.manifestfielddata }
                        multiline
                        rows="3"
                        rowsMax="3"
                        InputProps={{ classes: { root: classes.textFieldip } }}
                        value= { props.doo.droppointname + '\r\n'+ (props.doo.dropinfo? props.doo.dropinfo.addr1 +'\n'+ (props.doo.dropinfo.addr2? props.doo.dropinfo.addr2+'\n' : '') + props.doo.dropinfo.city+','+props.doo.dropinfo.state +' '+props.doo.dropinfo.zip : '') }
                        variant="outlined"
                      />
                    </div>
                  </Grid>
                </Grid>           
              </div>
              <hr />
              <div className={ RfsStyles.mainfestRow }>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Truck Type</h3>

                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value= { props.doo.truck_type }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Pick Up FromTrucking Company</h3>

                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value= { props.doo.delivery_company_name }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') } > 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Drivers Name</h3>

                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value= { props.doo.driver_name }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Drivers ID</h3>

                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value= { props.doo.driver_id }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Truck Plate</h3>
                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value= { props.doo.driver_vehichle_registration }
                      variant="outlined"
                    />
                  </div>
                </div>
              </div>
              <div className={ RfsStyles.mainfestRow }>
              
                <div className={ [RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                  </div>
                    <RadioGroup
                      name="isSealed"
                      row={ true }
                    >
                      <FormControlLabel 
                        value="Locked" 
                        className={ classes.truckTypeRadio }
                        control={
                          <Radio
                            disabled
                            checked={ props.doo.locked === true }
                            icon={ <RadioButtonUnchecked color='primary' /> }
                            checkedIcon={ <RadioButtonChecked color='primary' /> }
                          /> 
                        } 
                        label={<Typography> Locked</Typography>}
                      />
                      
                    </RadioGroup>
                </div>

                <div className={ [RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') }> 
                  </div>
                    <FormControlLabel 
                      value="Sealed" 
                      className={ classes.truckTypeRadio }
                      control={
                        <Radio
                          disabled
                          checked={ props.doo.sealed === true}
                          icon={ <RadioButtonUnchecked color='primary' /> }
                          checkedIcon={ <RadioButtonChecked color='primary' /> }
                        /> 
                      } 
                      label={<Typography>Sealed</Typography>}
                    />
                </div>

                

                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') } style={{ width: '100%' }}> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Seal Number</h3>
       
                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value={ props.doo.seal_number }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder,RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') } style={{ width: '100%' }}> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Drivers STA</h3>

                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value= { props.doo.sta }
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className={ [classes.mainfestfieldborder, RfsStyles.maxWid23].join(' ') } >
                  <div className={ [commonStyles.inputWrapper,commonStyles.w100].join(' ') } style={{ width: '100%' }}> 
                    <h3 className={ [commonStyles.inputLabel, commonStyles.my0].join(' ') } >Billing Reference Number</h3>

                    <TextField
                      id="outlined-helperText"
                      disabled={ true }
                      className={ classes.manifestfielddata }
                      value={ props.doo.bill_to.full_address }
                      variant="outlined"
                    />
                  </div>
                </div>

              </div>
              <div className={ classes.tableWrapperPadding }>
                <div className= { `${ commonStyles.wrapper }` }>
                  <h3 className={ commonStyles.header } >Add Airwaybills to Manifest</h3>
                  <MaterialTable
                    components={{Container: props => <Paper {...props} elevation={0} className={ `${ commonStyles.paperTable }` }/>}}
                    icons={ tableIcons }
                    data={ props.doo.list ? props.doo.list: [] }
                    columns={[ 
                      { title: "Awbs", field: "rfs_number", render: (rowData: any) => { return `${rowData.code}-${rowData.number}`; } },
                      { title: "Pcs", field: "num_awbs", render: (rowData: any) => { return `${rowData.pieces}`; } },
                      { title: "Wgt", field: "weight", render: (rowData: any) => { return `${rowData.weight}K`; } },
                      { title: "Specials", field: "special", render: (rowData: any) => { return `${rowData.specials}`; } },
                      { title: "Remarks", field: "remarks", render: (rowData: any) => { return `${rowData.remarks_text}`; } },
                  
                    ]}
                    options={{
                      search: false,
                      paging: false,
                      showTitle: false,
                      actionsColumnIndex: -1,
                      toolbar: false,
                      sorting: true,
                      headerStyle: {
                        backgroundColor: 'var(--tbl_head_bkg)',
                        color: 'var(--tbl_head_color)',
                        zIndex: 2,
                      },
                    }}
                  />
                </div>

              </div>
              <div className={ RfsStyles.commentSection } >
                <TextField
                  fullWidth
                  label="Comments - Origin Station"
                  disabled={ false }
                  variant="outlined"
                  value={ props.doo.org_comment }            
                  InputProps={{ 
                    classes: { notchedOutline: `${commonStyles.notchedOutline} ${commonStyles.noNotch}` },
                  }}
                  className={commonStyles.customTextField}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                />
                <TextField
                  fullWidth
                  label="Comments - Destination Station"
                  disabled={ false }
                  variant="outlined"
                  value={ props.doo.dst_comment }            
                  InputProps={{ 
                    classes: { notchedOutline: `${commonStyles.notchedOutline} ${commonStyles.noNotch}` },
                  }}
                  className={commonStyles.customTextField}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                />
              </div>
              
              <div className={ RfsStyles.mainfestRow }>
                <p className={ RfsStyles.mainfestP }>All cargo received in full and in good apparent order expect as noted in comments above.</p>
              </div>
              <div className={ RfsStyles.mainfestRow +' '+ RfsStyles.signatureWrap }>
                <div className={ RfsStyles.mainfestSign }>
                  { props.doo.driver_signature_key && 
                    <img className={ RfsStyles.signature }  src={ props.savedSignatureUrl } />
                  }
                  <hr/>
                    <p>
                    <span>
                      {"Trucker: " + (props.doo.driver_name || '') + (props.doo.delivery_company_name ? '-' + (props.doo.delivery_company_name || '') : '')}
                    </span>
                    </p>
                </div>
                <div className={ RfsStyles.mainfestSign }/>
                <div className={ RfsStyles.mainfestSign }>
                { props.doo.gha_wh_user_name }
                  <hr/>
                  <p><span>{"Polar Air Cargo"}</span></p>
                </div>
              </div>

            </div> 
          </div>
        </div>
      </div>
    // </Dialog>
  );
};

export default withStyles(styles)(manifestInfo);
